/**
 * @generated SignedSource<<54f77c527e53a51e3d262c6a1a292339>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuyerProductImageWithPrice_item$data = {
  readonly productPhotos: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"ProductImage_photo">;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"ProductImage_item" | "ProductPriceBadge_item">;
  readonly " $fragmentType": "BuyerProductImageWithPrice_item";
};
export type BuyerProductImageWithPrice_item$key = {
  readonly " $data"?: BuyerProductImageWithPrice_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuyerProductImageWithPrice_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isTrade"
    },
    {
      "defaultValue": "searchAndBrowse",
      "kind": "LocalArgument",
      "name": "pageDisplayEnum"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "priceBookName"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyerProductImageWithPrice_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductImage_item"
    },
    {
      "alias": "productPhotos",
      "args": [
        {
          "kind": "Literal",
          "name": "limit",
          "value": 1
        }
      ],
      "concreteType": "ItemPhoto",
      "kind": "LinkedField",
      "name": "photos",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProductImage_photo"
        }
      ],
      "storageKey": "photos(limit:1)"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "pageDisplayEnum",
          "variableName": "pageDisplayEnum"
        },
        {
          "kind": "Variable",
          "name": "priceBookName",
          "variableName": "priceBookName"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ProductPriceBadge_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "5513b8cfcf75967a22d4a88e8fdddac8";

export default node;
